import React, { useEffect, useState } from 'react';
import { TennisLiveApi } from '../../services/TennisLiveApi';
import './Giro.css';

interface HeadToHeadPanelProps {
  player1Id: number;
  player2Id: number;
  player1Name: string;
  player2Name: string;
  onPlayerClick?: (id: number, name: string) => void;
}

export const HeadToHeadPanel: React.FC<HeadToHeadPanelProps> = ({ player1Id, player2Id, player1Name, player2Name, onPlayerClick }) => {
  const [h2hData, setH2hData] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchH2H = async () => {
      setLoading(true);
      const data = await TennisLiveApi.getHeadToHead(player1Id, player2Id);
      if (data) {
        setH2hData(data);
      }
      setLoading(false);
    };
    fetchH2H();
  }, [player1Id, player2Id]);

  if (loading) {
    return <div className="gr-h2h-panel gr-loading">Carregando H2H...</div>;
  }

  if (!h2hData || !h2hData.result) {
    return <div className="gr-h2h-panel gr-error">H2H não disponível para {player1Name} vs {player2Name}</div>;
  }

  // Estatísticas H2H simuladas ou calculadas com base nos jogos da API
  const matches = h2hData.result.H2H || [];
  let p1Wins = 0;
  let p2Wins = 0;
  
  matches.forEach((m: any) => {
    // Check who won using event_winner which is "First Player" or "Second Player"
    if (m.event_winner === 'First Player') p1Wins++;
    if (m.event_winner === 'Second Player') p2Wins++;
  });

  return (
    <div className="gr-h2h-panel">
      <div className="gr-h2h-header">
        <h4>HEAD-TO-HEAD PLAYER DATA</h4>
        <div className="gr-h2h-players">
          <div 
            className="gr-h2h-player" 
            onClick={() => onPlayerClick && onPlayerClick(player1Id, player1Name)}
            style={{ cursor: onPlayerClick ? 'pointer' : 'default' }}
          >
            <span className="gr-h2h-name">{player1Name}</span>
            <span className="gr-h2h-wins">{p1Wins}</span>
          </div>
          <div className="gr-h2h-vs">VS</div>
          <div 
            className="gr-h2h-player" 
            onClick={() => onPlayerClick && onPlayerClick(player2Id, player2Name)}
            style={{ cursor: onPlayerClick ? 'pointer' : 'default' }}
          >
            <span className="gr-h2h-wins">{p2Wins}</span>
            <span className="gr-h2h-name">{player2Name}</span>
          </div>
        </div>
      </div>

      <div className="gr-h2h-stats">
        <h5 className="gr-h2h-subtitle">H2H STATS THAT HELP TO PREDICT</h5>
        {matches.length === 0 ? (
          <p className="gr-no-data">Nenhum confronto direto anterior encontrado.</p>
        ) : (
          <div className="gr-stat-bars">
            <div className="gr-stat-bar-row">
              <span className="gr-stat-value-left">{p1Wins}</span>
              <div className="gr-progress-container">
                <div className="gr-progress-left" style={{ width: `${(p1Wins / (p1Wins + p2Wins)) * 100}%` }}></div>
                <div className="gr-progress-right" style={{ width: `${(p2Wins / (p1Wins + p2Wins)) * 100}%` }}></div>
              </div>
              <span className="gr-stat-value-right">{p2Wins}</span>
            </div>
            <span className="gr-stat-label-center">Vitórias</span>
          </div>
        )}
      </div>
    </div>
  );
};
